// Code review - Completed
// Documentation - Completed
import { useEffect, useRef, useState } from "react";
import { mainTable } from "../css/Common";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MainPopup from "../popup-containers/MainPopup";
import youtube from "../image/youtube.jpg";
import pdf from "../image/pdf.png";
import download from "../image/download.png";
import { BindAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
const TableGrid = ({
  tableHeight,
  headerData,
  tableData,
  onEditGrid,
  onViewGrid,
  onDeleteGrid,
  onBlockGrid,
  onAddressGrid,
  currentPage,
  itemsPerPage,
  viewBag,
  editBag,
  deleteBag,
  blockBag,
  serviceBag,
  onSchoolView,
  tableView,
  xScroll,
  tableScroll,
  onAdd,
  onDisabled,
  onNoOfReferences,
  onViewFile,
}) => {
  let currentData = [];

  const location = useLocation();
  const [moduleDelete, setModuleDelete] = useState(false);
  const [topicDelete, setTopicDelete] = useState(false);
  const [questionDelete, setQuestionDelete] = useState(false);
  const [bindDeleteActionData, setBindDeleteActionData] = useState([]);

  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [NODtoEditPastEntries, setNODtoEditPastEntries] = useState("");
  const [action, setAction] = useState([]);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const gridRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState("bottom");
  const [startIndex, setStartIndex] = useState(0);

  const toggleDropdown = (event, rowIndex) => {
    const buttonElement = event.currentTarget;
    const gridElement = gridRef.current;

    if (!buttonElement || !gridElement) return;

    const buttonRect = buttonElement.getBoundingClientRect();
    const gridRect = gridElement.getBoundingClientRect();

    const dropdownHeight = 160; // approx dropdown height in px
    const spaceBelow = gridRect.bottom - buttonRect.bottom;

    if (spaceBelow < dropdownHeight) {
      setDropdownPosition("top");
    } else {
      setDropdownPosition("bottom");
    }

    showPopUp(!viewsAll, rowIndex);
  };

  if (currentPage) {
    if (Array.isArray(tableData)) {
      if (itemsPerPage === -1) {
        currentData = tableData; // No slicing, show all data
      } else {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        currentData = tableData.slice(startIndex, endIndex); // Pagination logic
      }
    }
  } else {
    currentData = [tableData];
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        showPopUp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const navigate = useNavigate();
  const [viewsAll, setViewsAll] = useState(false);

  const [viewImage, setViewImage] = useState({ popup: false, url: "" });
  const [currentRowIndex, setCurrentRowIndex] = useState(null);

  const systemSettingsData = async () => {
    const response = await BindAPI("SystemSettingsAPI/BindSystemSettings");
    const NODtoEditPastEntriesFromApi =
      response.data.Table[0].NODtoEditPastEntries;
    setNODtoEditPastEntries(NODtoEditPastEntriesFromApi);
  };

  const showPopUp = (views, rowIndex) => {
    setViewsAll(views);
    setCurrentRowIndex(views ? rowIndex : null);
  };
  useEffect(() => {
    systemSettingsData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (location.pathname === "/module") {
        setModuleDelete(true);
        const response = await BindAPI("TopicAPI/BindTopics");
        setBindDeleteActionData(response.data.Table);
      } else if (location.pathname === "/topic") {
        setTopicDelete(true);
        const response = await BindAPI("QuestionsAPI/BindQuestions");
        setBindDeleteActionData(response.data.Table);
      } else if (location.pathname === "/questions") {
        setQuestionDelete(true);
        const response = await BindAPI(
          "AnswerQuestionsAPI/BindAnswerQuestionsforDelete"
        );
        setBindDeleteActionData(response.data.Table);
      } else {
        setModuleDelete(false);
        setQuestionDelete(false);
        setTopicDelete(false);
      }
    };

    fetchData();
  }, [location]);

  return (
    <div className={mainTable.tableShadowWidth}>
      <div
        className={`${tableScroll ? tableScroll : mainTable.table}`}
        role="table"
      >
        <div className={`${xScroll ? xScroll : mainTable.xScroll}`}>
          <div className={mainTable.tableHeader} role="rowgroup">
            {headerData.map((item, itemIndex) => (
              <div className={item.width} role="columnheader">
                <label class="text-sm  font-medium">{item.title}</label>
              </div>
            ))}
          </div>

          <div
            ref={gridRef}
            className={`overflow-y-auto ${
              tableHeight ? tableHeight : "h-80 overflow-y-auto"
            } `}
          >
            {currentData.length > 0 ? (
              currentData.map((data, rowIndex) => (
                <div class={mainTable.tableRow}>
                  {headerData.map((keyData) => (
                    <div scope="cell" role="cell" className={keyData.width}>
                      {keyData.key === "address" ||
                      keyData.key === "details" ? (
                        <button
                          onClick={() => onAddressGrid(data.oldIndex, 1)}
                          class="relative px-5 py-2 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group"
                        >
                          <span class="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-gray-600 group-hover:w-full ease"></span>
                          <span class="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
                          <span class="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                          <span class="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                          <span class="absolute inset-0 w-full h-full duration-300 delay-300 bg-gray-900 opacity-0 group-hover:opacity-100"></span>
                          <span class="relative transition-colors duration-300 delay-200 group-hover:text-white ease">
                            View
                          </span>
                        </button>
                      ) : keyData.key === "action" ? (
                        <div className="relative inline-block">
                          <button
                            ref={buttonRef}
                            id={`dropdownMenuIconButton-${rowIndex}`}
                            aria-haspopup="true"
                            aria-expanded={
                              viewsAll && currentRowIndex === rowIndex
                            }
                            className="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={(e) => toggleDropdown(e, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id={`dropdownDots-${rowIndex}`}
                              className="z-10 bg-white absolute right-0 divide-y divide-gray-100 rounded-lg shadow w-44"
                              style={{
                                top:
                                  dropdownPosition === "bottom"
                                    ? "100%"
                                    : "auto",
                                bottom:
                                  dropdownPosition === "top" ? "100%" : "auto",
                                marginTop:
                                  dropdownPosition === "bottom"
                                    ? "0.5rem"
                                    : "0",
                                marginBottom:
                                  dropdownPosition === "top" ? "0.5rem" : "0",
                              }}
                              role="menu"
                              aria-labelledby={`dropdownMenuIconButton-${rowIndex}`}
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 &&
                                  !data.InActivatedBy &&
                                  data.Type != "VCP" && (
                                    <li>
                                      <a
                                        onClick={() => {
                                          onEditGrid(data.oldIndex, 2);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Edit
                                      </a>
                                    </li>
                                  )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        if (moduleDelete) {
                                          const isModuleIdPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstModuleId ===
                                                data.MstModuleId
                                            );
                                          if (isModuleIdPresent) {
                                            toast.error(
                                              "This module cannot be deleted as there are topics attached to this 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else if (topicDelete) {
                                          const isTopicIdPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstTopicId ===
                                                data.MstTopicId
                                            );
                                          if (isTopicIdPresent) {
                                            toast.error(
                                              "This topic cannot be deleted as there are question attached to this 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else if (questionDelete) {
                                          const isQuestionPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstQuestionsId ===
                                                data.MstQuestionsId
                                            );
                                          if (isQuestionPresent) {
                                            toast.error(
                                              "This question cannot be deleted as this Question has been Answered 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else {
                                          onDeleteGrid(data.oldIndex, 3);
                                          showPopUp(false);
                                        }
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                                {blockBag == 1 && (
                                  <li>
                                    {data.InActivatedBy ? (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 5);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Active
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 4);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Inactive
                                      </a>
                                    )}
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "UploadAction" ? (
                        <div className="relative inline-block">
                          <button
                            ref={buttonRef}
                            id={`dropdownMenuIconButton-${rowIndex}`}
                            aria-haspopup="true"
                            aria-expanded={
                              viewsAll && currentRowIndex === rowIndex
                            }
                            className="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={(e) => toggleDropdown(e, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id={`dropdownDots-${rowIndex}`}
                              className="z-10 bg-white absolute right-0 divide-y divide-gray-100 rounded-lg shadow w-44"
                              style={{
                                top:
                                  dropdownPosition === "bottom"
                                    ? "100%"
                                    : "auto",
                                bottom:
                                  dropdownPosition === "top" ? "100%" : "auto",
                                marginTop:
                                  dropdownPosition === "bottom"
                                    ? "0.5rem"
                                    : "0",
                                marginBottom:
                                  dropdownPosition === "top" ? "0.5rem" : "0",
                              }}
                              role="menu"
                              aria-labelledby={`dropdownMenuIconButton-${rowIndex}`}
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 &&
                                  !data.InActivatedBy &&
                                  data.Type != "VCP" && (
                                    <li>
                                      <a
                                        onClick={() => {
                                          onEditGrid(data.oldIndex, 2);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Edit
                                      </a>
                                    </li>
                                  )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        if (moduleDelete) {
                                          const isModuleIdPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstModuleId ===
                                                data.MstModuleId
                                            );
                                          if (isModuleIdPresent) {
                                            toast.error(
                                              "This module cannot be deleted as there are topics attached to this 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else if (topicDelete) {
                                          const isTopicIdPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstTopicId ===
                                                data.MstTopicId
                                            );
                                          if (isTopicIdPresent) {
                                            toast.error(
                                              "This topic cannot be deleted as there are question attached to this 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else if (questionDelete) {
                                          const isQuestionPresent =
                                            bindDeleteActionData.some(
                                              (item) =>
                                                item.MstQuestionsId ===
                                                data.MstQuestionsId
                                            );
                                          if (isQuestionPresent) {
                                            toast.error(
                                              "This question cannot be deleted as this Question has been Answered 👎",
                                              {
                                                duration: 5000,
                                                position: "top-center",
                                              }
                                            );
                                          } else {
                                            onDeleteGrid(data.oldIndex, 3);
                                            showPopUp(false);
                                          }
                                        } else {
                                          onDeleteGrid(data.oldIndex, 3);
                                          showPopUp(false);
                                        }
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                                {blockBag == 1 && (
                                  <li>
                                    {data.InActivatedBy ? (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 5);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Active
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() => {
                                          onBlockGrid(data.oldIndex, 4);
                                          showPopUp(false);
                                        }}
                                        class="block px-4 py-2 hover:bg-gray-100"
                                      >
                                        Make Inactive
                                      </a>
                                    )}
                                  </li>
                                )}
                                {serviceBag == 1 && data.Type == "VCP" && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 6);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Upload Invoices
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "DeleteAction" ? (
                        <div className="relative inline-block">
                          {deleteBag === 1 && (
                            <svg
                              onClick={() => {
                                onDeleteGrid(data.oldIndex, 3);
                                showPopUp(false);
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-5 h-5 text-red-600 cursor-pointer hover:text-red-800"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m2 0H7m4-3h2a1 1 0 011 1v1H8V5a1 1 0 011-1z"
                              />
                            </svg>
                          )}
                        </div>
                      ) : keyData.key === "FileName" ? (
                        <div className="relative inline-block max-w-[200px]">
                          <span
                            onClick={() => {
                              onViewFile(data.oldIndex, 3);
                              showPopUp(false);
                            }}
                            className="truncate cursor-pointer underline hover:text-red-800 block"
                            title={data.FileName} // Tooltip on hover
                          >
                            {data.FileName}
                          </span>
                        </div>
                      ) : keyData.key === "NoOfReferences" ? (
                        <div className="relative inline-block">
                          <button
                            onClick={() => {
                              onNoOfReferences(data.oldIndex, 4);
                              showPopUp(false);
                            }}
                            className="text-blue-600 underline hover:text-blue-800"
                          >
                            {data.NoOfReferences}
                          </button>
                        </div>
                      ) : keyData.key === "ProformaInvoice" ? (
                        <div className="relative inline-block max-w-[200px]">
                          <span
                            onClick={() => {
                              
                              if (!data?.ProformaInvoice) {
                                // alert("Proforma Invoice is not available"); // You can replace with toast
                                return;
                              }
                              onViewFile(data.oldIndex, 3, 1);
                              showPopUp(false);
                            }}
                            className={`truncate underline block ${
                              data?.ProformaInvoice
                                ? "hover:text-green-800 text-green-500 cursor-pointer"
                                : "text-red-500 cursor-not-allowed"
                            }`}
                            title={
                              data?.ProformaInvoice
                                ? data.FileName
                                : "Proforma Invoice is not available"
                            }
                          >
                            View
                          </span>
                        </div>
                      ) : keyData.key === "TaxInvoice" ? (
                        <div className="relative inline-block max-w-[200px]">
                          <span
                            onClick={() => {
                              
                              if (!data?.TaxInvoice) {
                                // alert("Proforma Invoice is not available"); // You can replace with toast
                                return;
                              }
                              onViewFile(data.oldIndex, 3, 2);
                              showPopUp(false);
                            }}
                            className={`truncate underline block ${
                              data?.TaxInvoice
                                ? "hover:text-green-800 text-green-500 cursor-pointer"
                                : "text-red-500 cursor-not-allowed"
                            }`}
                            title={
                              data?.TaxInvoice
                                ? data.FileName
                                : "Tax Invoice is not available"
                            }
                          >
                            View
                          </span>
                        </div>
                      ) : keyData.key === "PaymentInfoAction" ? (
                        <div className="flex justify-center">
                          <Link
                            to={"/paymentinfo"}
                            state={{
                              ...data,
                              isAdd: true,
                              isvisible3: false,
                              isData: tableData[rowIndex],
                              menuId: 13,
                            }}
                            // onClick={() => onServiceProvideGrid(rowIndex)}
                            className={mainTable.addButton}
                          >
                            Add
                          </Link>
                        </div>
                      ) : keyData.key === "actionWithOutInactive" ? (
                        <div className="relative inline-block">
                          <button
                            ref={buttonRef}
                            id={`dropdownMenuIconButton-${rowIndex}`}
                            aria-haspopup="true"
                            aria-expanded={
                              viewsAll && currentRowIndex === rowIndex
                            }
                            className="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={(e) => toggleDropdown(e, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id={`dropdownDots-${rowIndex}`}
                              className="z-10 bg-white absolute right-0 divide-y divide-gray-100 rounded-lg shadow w-44"
                              style={{
                                top:
                                  dropdownPosition === "bottom"
                                    ? "100%"
                                    : "auto",
                                bottom:
                                  dropdownPosition === "top" ? "100%" : "auto",
                                marginTop:
                                  dropdownPosition === "bottom"
                                    ? "0.5rem"
                                    : "0",
                                marginBottom:
                                  dropdownPosition === "top" ? "0.5rem" : "0",
                              }}
                              role="menu"
                              aria-labelledby={`dropdownMenuIconButton-${rowIndex}`}
                            >
                              <ul
                                class="z-20"
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,

                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                                {deleteBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onDeleteGrid(
                                          data.oldIndex,

                                          3
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Delete
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "actionWithOutInactiveAndDelete" ? (
                        <div className="relative inline-block">
                          <button
                            ref={buttonRef}
                            id={`dropdownMenuIconButton-${rowIndex}`}
                            aria-haspopup="true"
                            aria-expanded={
                              viewsAll && currentRowIndex === rowIndex
                            }
                            className="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={(e) => {
                              toggleDropdown(e, rowIndex);
                            }}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                          {viewsAll && currentRowIndex == rowIndex && (
                            <div
                              ref={dropdownRef}
                              id={`dropdownDots-${rowIndex}`}
                              className="z-10 bg-white absolute right-0 divide-y divide-gray-100 rounded-lg shadow w-44"
                              style={{
                                top:
                                  dropdownPosition === "bottom"
                                    ? "100%"
                                    : "auto",
                                bottom:
                                  dropdownPosition === "top" ? "100%" : "auto",
                                marginTop:
                                  dropdownPosition === "bottom"
                                    ? "0.5rem"
                                    : "0",
                                marginBottom:
                                  dropdownPosition === "top" ? "0.5rem" : "0",
                              }}
                              role="menu"
                              aria-labelledby={`dropdownMenuIconButton-${rowIndex}`}
                            >
                              <ul
                                class=""
                                aria-labelledby="dropdownMenuIconButton"
                              >
                                {viewBag == 1 && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onViewGrid(data.oldIndex, 1);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      View
                                    </a>
                                  </li>
                                )}
                                {editBag == 1 && !data.InActivatedBy && (
                                  <li>
                                    <a
                                      onClick={() => {
                                        onEditGrid(
                                          data.oldIndex,

                                          2
                                        );
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Edit
                                    </a>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      ) : keyData.key === "Report" ? (
                        <div className="flex">
                          <div className="flex flex-col gap-y-2">
                            <button
                              id="dropdownMenuIconButton"
                              data-dropdown-toggle="dropdownDots"
                              className="inline-flex items-center gap-1 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                              type="button"
                              onClick={() => onSchoolView(rowIndex)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                              >
                                <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.103.897 2 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM8 15v-4h1.5a1.5 1.5 0 1 1 0 3H9v1H8zm4-2h1.5v-1H12v-1h2v4h-2v-1zm4.5 1.5v-3h-1v-1H18v4h-1.5z" />
                              </svg>
                              View
                            </button>
                          </div>
                        </div>
                      ) : keyData.key === "AttachmentFile"
                      //  && data[keyData.key]
                         ? (
                        <img
                          onClick={() =>{
                             onViewFile(data.oldIndex, 3, 1);
                              showPopUp(false);
                            // window.open(data[keyData.key], "_blank")
                          }
                          }
                          src={pdf} // your static PDF icon for all files
                          alt="File"
                          className="cursor-pointer rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : keyData.key === "Attachment" ? (
                        <div className="flex flex-col items-center gap-2">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            type="button"
                            className="w-20 h-9 bg-gray-800 text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                            onClick={() => onViewGrid(rowIndex)}
                          >
                            View
                          </button>
                        </div>
                      ) : keyData.title === "S.No." ? (
                        <div>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      ) : keyData.title === "S.No." && data.InActivatedBy ? (
                        <div class={keyData.width1}>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      ) : keyData.key === "userImage" ||
                        keyData.key === "UserProfileImg" ? ( // Will be used in functionality
                        <img
                          class={``}
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key] ? data[keyData.key] : download}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 1 ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 2 &&
                        data[keyData.key]?.startsWith(
                          "https://www.youtube.com/embed/"
                        ) ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={youtube}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data[keyData.key1] === 3 &&
                        data[keyData.key]?.endsWith(".pdf") ? (
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={pdf}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      ) : data.InActivatedBy ? (
                        <div className={keyData.width1}>
                          <div
                            class="truncate relative text-red-600"
                            title={data[keyData.key]}
                          >
                            {data[keyData.key]}
                          </div>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      ) : (
                        <div class="relative">
                          <div
                            class="truncate relative"
                            title={data[keyData.key]}
                          >
                            {data[keyData.key]}
                          </div>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div class="text-center text-red-500 mt-4">No record found</div>
            )}
          </div>
        </div>
      </div>

      <div className={mainTable.tableMobile} role="table">
        <div
          className={`w-full ${
            tableView ? "" : "overflow-y-auto"
          } lg:h-96 h-full`}
        >
          {currentData.length > 0 &&
            currentData.map((data, rowIndex) => (
              <div scope="col" class={mainTable.mobileTable}>
                {headerData.map((keyData) => (
                  <div scope="cell" class={mainTable.tableData} role="cell">
                    {keyData.key === "address" ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div className="flex basis-1/2">
                          <button
                            onClick={() => onAddressGrid(data.oldIndex, 1)}
                            class="relative px-5 py-2 overflow-hidden font-medium text-gray-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner group"
                          >
                            <span class="absolute top-0 left-0 w-0 h-0 transition-all duration-200 border-t-2 border-gray-600 group-hover:w-full ease"></span>
                            <span class="absolute bottom-0 right-0 w-0 h-0 transition-all duration-200 border-b-2 border-gray-600 group-hover:w-full ease"></span>
                            <span class="absolute top-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                            <span class="absolute bottom-0 left-0 w-full h-0 transition-all duration-300 delay-200 bg-gray-600 group-hover:h-full ease"></span>
                            <span class="absolute inset-0 w-full h-full duration-300 delay-300 bg-gray-900 opacity-0 group-hover:opacity-100"></span>
                            <span class="relative transition-colors duration-300 delay-200 group-hover:text-white ease">
                              View
                            </span>
                          </button>
                        </div>
                      </div>
                    ) : keyData.key === "actionWithOutInactive" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                          )}
                          {editBag === 1 && !data.InActivatedBy && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => {
                                onEditGrid(data.oldIndex, 2);
                                showPopUp(false);
                              }}
                            >
                              Edit
                            </button>
                          )}
                          {deleteBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onDeleteGrid(data.oldIndex, 3)}
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      </div>
                    ) : keyData.key === "action" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                          )}
                          {editBag === 1 &&
                            !data.InActivatedBy &&
                            data.Type != "VCP" && (
                              <button
                                className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                                onClick={() => {
                                  onEditGrid(data.oldIndex, 2);
                                  showPopUp(false);
                                }}
                              >
                                Edit
                              </button>
                            )}
                          {deleteBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onDeleteGrid(data.oldIndex, 3)}
                            >
                              Delete
                            </button>
                          )}
                          {blockBag === 1 && (
                            <div className="w-full">
                              {data.InActivatedBy ? (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 5);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#1f2a44] w-full text-white p-2 rounded-lg"
                                >
                                  Active
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 4);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#1f2a44] w-full text-white p-2 rounded-lg"
                                >
                                  Inactive
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : keyData.key === "UploadAction" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex gap-1 justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onViewGrid(data.oldIndex, 1)}
                            >
                              View
                            </button>
                          )}
                          {editBag === 1 &&
                            !data.InActivatedBy &&
                            data.Type != "VCP" && (
                              <button
                                className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                                onClick={() => {
                                  onEditGrid(data.oldIndex, 2);
                                  showPopUp(false);
                                }}
                              >
                                Edit
                              </button>
                            )}
                          {deleteBag === 1 && (
                            <button
                              className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                              onClick={() => onDeleteGrid(data.oldIndex, 3)}
                            >
                              Delete
                            </button>
                          )}
                          {blockBag === 1 && (
                            <div className="w-full">
                              {data.InActivatedBy ? (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 5);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#1f2a44] w-full text-white p-2 rounded-lg"
                                >
                                  Active
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    onBlockGrid(data.oldIndex, 4);
                                    showPopUp(false);
                                  }}
                                  className="bg-[#1f2a44] w-full text-white p-2 rounded-lg"
                                >
                                  Inactive
                                </button>
                              )}
                            </div>
                          )}
                          {serviceBag == 1 &&
                            data.Type == "VCP" && (
                              <button
                                className="bg-[#1f2a44] w-full text-white p-1 rounded-lg"
                                onClick={() => {
                                  onViewGrid(data.oldIndex, 6);
                                  showPopUp(false);
                                }}
                              >
                                Invoices
                              </button>
                            )}
                        </div>
                      </div>
                    ): keyData.key === "ProformaInvoice" ? (
                      <div className="">
                        <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <div className="flex basis-1/2 truncate relative text-red-600">
                        <span
                          onClick={() => {
                            
                            if (!data?.ProformaInvoice) {
                              // alert("Proforma Invoice is not available"); // You can replace with toast
                              return;
                            }
                            onViewFile(data.oldIndex, 3, 1);
                            showPopUp(false);
                          }}
                          className={`truncate underline block ${
                            data?.ProformaInvoice
                              ? "hover:text-green-800 text-green-500 cursor-pointer"
                              : "text-red-500 cursor-not-allowed"
                          }`}
                          title={
                            data?.ProformaInvoice
                              ? data.FileName
                              : "Proforma Invoice is not available"
                          }
                        >
                          View
                        </span>
                      </div>
                      </div>
                      </div>
                    ) : keyData.key === "TaxInvoice" ? (
                      <div className="">
                        <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <div className="flex basis-1/2 truncate relative text-red-600">
                            <span
                              onClick={() => {
                                
                                if (!data?.TaxInvoice) {
                                  // alert("Proforma Invoice is not available"); // You can replace with toast
                                  return;
                                }
                                onViewFile(data.oldIndex, 3, 2);
                                showPopUp(false);
                              }}
                              className={`truncate underline block ${
                                data?.TaxInvoice
                                  ? "hover:text-green-800 text-green-500 cursor-pointer"
                                  : "text-red-500 cursor-not-allowed"
                              }`}
                              title={
                                data?.TaxInvoice
                                  ? data.FileName
                                  : "Tax Invoice is not available"
                              }
                            >
                              View
                            </span>
                          </div>
                        </div>
                      </div>
                    ): keyData.key === "NoOfReferences" ? (
                         <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <button
                            onClick={() => {
                              onNoOfReferences(data.oldIndex, 4);
                              showPopUp(false);
                            }}
                            className="text-blue-600 underline hover:text-blue-800"
                          >
                            {data.NoOfReferences}
                          </button>
                        </div>
                      ): keyData.key === "FileName" ? (
                         <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <span
                            onClick={() => {
                              onViewFile(data.oldIndex, 3);
                              showPopUp(false);
                            }}
                            className="truncate cursor-pointer underline hover:text-red-800 block"
                            title={data.FileName} // Tooltip on hover
                          >
                            {data.FileName}
                          </span>
                        </div>
                      ) : keyData.key === "PaymentInfoAction" ? (
                      <div className="flex justify-center">
                        <Link
                          to={"/paymentinfo"}
                          state={{
                            ...data,
                            isAdd: true,
                            isvisible3: false,
                            isData: tableData[rowIndex],
                            menuId: 13,
                          }}
                          // onClick={() => onServiceProvideGrid(rowIndex)}
                          className={mainTable.addButton}
                        >
                          Add
                        </Link>
                      </div>
                    ) : keyData.key === "DeleteAction" ? (
                        <div className="flex flex-col items-center gap-2">
                          {deleteBag === 1 && (
                            <svg
                              onClick={() => {
                                onDeleteGrid(data.oldIndex, 3);
                                showPopUp(false);
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-5 h-5 text-red-600 cursor-pointer hover:text-red-800"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m2 0H7m4-3h2a1 1 0 011 1v1H8V5a1 1 0 011-1z"
                              />
                            </svg>
                          )}
                        </div>
                      ) : keyData.key === "Attachment" ? (
                        <div className="flex flex-col items-center gap-2">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            type="button"
                            className="w-20 h-9 bg-gray-800 text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                            onClick={() => onViewGrid(rowIndex)}
                          >
                            View
                          </button>
                        </div>
                      ): keyData.key === "userImage" ||
                      keyData.key === "UserProfileImg" ? (
                      <div className="flex justify-center ">
                        <input
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full  w-20 md:w-12 md:h-12"
                        />
                      </div>
                    ) : data[keyData.key1] === 1 ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={data[keyData.key]}
                          alt="Image"
                          className="rounded-full w-12 h-12  "
                          width={keyData.width}
                        />
                      </div>
                    ) : data[keyData.key1] === 2 &&
                      data[keyData.key]?.startsWith(
                        "https://www.youtube.com/embed/"
                      ) ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={youtube}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      </div>
                    ) : data[keyData.key1] === 3 &&
                      data[keyData.key]?.endsWith(".pdf") ? (
                      <div className="flex justify-center ">
                        <img
                          onClick={() => {
                            setViewImage(() => {
                              return { popup: true, url: data[keyData.key] };
                            });
                          }}
                          type="image"
                          src={pdf}
                          alt="Image"
                          className="rounded-full w-12 h-12"
                          width={keyData.width}
                        />
                      </div>
                    ) : keyData.title === "S.No." ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div>
                          {startIndex +
                            rowIndex +
                            1 +
                            (currentPage - 1) * itemsPerPage}
                        </div>
                      </div>
                    ) : keyData.key === "Report" ? (
                      <div className="flex">
                        <div className="flex flex-col gap-y-2">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            className="inline-flex items-center gap-1 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-50"
                            type="button"
                            onClick={() => onSchoolView(rowIndex)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.103.897 2 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM8 15v-4h1.5a1.5 1.5 0 1 1 0 3H9v1H8zm4-2h1.5v-1H12v-1h2v4h-2v-1zm4.5 1.5v-3h-1v-1H18v4h-1.5z" />
                            </svg>
                            View
                          </button>
                        </div>
                      </div>
                    ) : keyData.key === "Phone" && data.ClientPhoneNo == "" ? (
                      <div className="flex basis-1/2">{"-"}</div>
                    ) : data.InActivatedBy ? (
                      <div className={keyData.width1}>
                        <div className="flex border p-1 ">
                          <div className="flex basis-1/2 font-bold ">
                            {keyData.title}
                          </div>
                          <div className="flex basis-1/2 truncate relative text-red-600">
                            {data[keyData.key]}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2 font-bold">
                          {keyData.title}
                        </div>
                        <div className="flex basis-1/2">
                          {data[keyData.key]}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
      <MainPopup
        popUpOpen={viewImage.popup}
        setpopUpOpen={() => setViewImage({ popup: false, url: "" })}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={() => setViewImage({ popup: false, url: "" })}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div className="flex justify-center p-12 items-center">
            {viewImage?.url ? (
              viewImage.url.startsWith("https://www.youtube.com/embed/") ? (
                <iframe
                  title="Video"
                  src={viewImage.url}
                  allowFullScreen
                  className="h-96 w-96"
                ></iframe>
              ) : viewImage.url.endsWith(".pdf") ? (
                <a
                  href={viewImage.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={pdf} // You can replace this with a custom PDF icon
                    alt="PDF"
                    className="w-20 h-20"
                  />
                  <p>View PDF</p>
                </a>
              ) : (
                <img src={viewImage.url} className="h-96 w-96" />
              )
            ) : (
              <p>No image or video available</p>
            )}
          </div>
        </div>
      </MainPopup>
    </div>
  );
};

export default TableGrid;
